import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import PlaceOfDeliveryConsumptionDetail from "features/placeOfDelivery/pages/PlaceOfDeliveryConsumptionDetail";
import ConsumptionHistorySection from "./sections/ConsumptionHistorySection";

type Props = {};

const ProductionHistory = (props: Props) => {
  let match = useRouteMatch();

  // translations
  const { t } = useTranslation(["shared\\moduleNames"]);

  return (
    <Switch>
      <Route
        path={`${match.path}/:placeOfDeliveryId`}
        component={PlaceOfDeliveryConsumptionDetail}
      />
      <Route path={match.path}>
        <Header title={t("productionHistory.title")} includeBreadcrumbs />
        <ModuleContent>
          <ConsumptionHistorySection isProduction />
        </ModuleContent>
      </Route>
    </Switch>
  );
};

export default ProductionHistory;
